import script from "./CandidateShopOrdersIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateShopOrdersIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__